<template style="background-color: white;">
    <div style="background-color: white;">
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card flat class="box" id="box">
                <!-- {{ org_basic_data }} -->
                <v-col cols="12" sm="3" md="3" justify="start" class="no-display" v-if="comp_value_earn">
                    <center>
                        <v-btn @click="print()" class="info"> <v-icon left color="black">mdi-printer</v-icon>Proceed to print</v-btn>                        
                    </center>                    
                </v-col>
                <v-row >
               
                <div class="row align-center">
                    <v-col cols="12" sm="2" md="2" v-if="org_basic_data.trust_logo">
                        <center><img height="100" width="150" alt="logo" :src="org_basic_data.trust_logo" class="schl-logo" id="myImage"/></center>
                    </v-col>
                    <v-col class="text-center" cols="12" sm="8" md="8">
                        <h2>{{ org_basic_data.trust_name }}</h2>
                        <h1 style="text-transform: uppercase;">{{ org_basic_data.school_name }}</h1>
                        <h2 style="text-transform: uppercase;">{{emp_type}} Staff</h2>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <center><img height="100" width="150" alt="logo" :src="org_basic_data.school_logo" class="schl-logo" id="myImage"/></center>
                    </v-col>
                    <hr class="stud_details2"> 
                    <!-- <v-col class="mt-0 pt-0" cols="12" sm="12" md="12" v-if="org_basic_data.school_logo">
                        <div style="width: 100%;" class="stud_details2"></div>
                    </v-col> -->
                  
                </div>
                 </v-row>
                 <div class="row" v-if="comp_value_earn">
                    <v-col style="margin-left: 30%;" class="mt-0 pt-0" cols="12" sm="12" md="12">
                        <h3>Salary Sheet for the Month of {{ salary_month }}</h3>
                    </v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="12" md="12"><strong>Employee Code : {{ emp_code }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="12" md="12"><strong>Name of the Staff : {{ emp_name }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="12" md="12"><strong>Designation : {{ emp_designation }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>Section : {{ emp_section }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>PAN No : {{ pan_no }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>PF A/C No : {{ emp_pf_no }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>Bank A/C No : {{ emp_bank_ac_no }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>Increment Month : {{ increment_month }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>UAN No : {{ emp_uan_no }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="12" md="12"><strong>Scale : {{ pay_commision }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="12" md="12"><strong>Present Days : {{ working_days }}</strong></v-col>

                    <v-col cols="12" sm="6" md="6">
                        <table>
                            <thead>
                                <tr>
                                    <th style="text-align: left;" class="pl-2">Emoluments</th>
                                    <th style="text-align: right;" class="pr-2">Amounts</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="border: none !important;" v-for="cn,index in comp_value_earn" :key="index">
                                    <span class="pl-2"> <strong>{{ cn.comp_name }}</strong> </span>
                                    <td style="text-align: right;" class="pr-2">{{ cn.comp_value }}.00</td>
                                </tr>
                                <tr v-if="comp_flag_earn" style="border: none !important;" v-for="index in this.comp_loop_value" :key="index">
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr >
                                    <td class="pl-2">Total Pay</td>
                                    <td style="text-align: right;" class="pr-2">{{ total_pay }}.00</td>
                                </tr>
                                <tr>
                                    <td class="pl-2">Total Dues</td>
                                    <td style="text-align: right;" class="pr-2">{{ total_earn }}.00</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" style="margin-left: -24px;">
                        <table>
                            <thead>
                                <tr>
                                    <th style="text-align: left;" class="pl-2">Deductions</th>
                                    <th style="text-align: right;" class="pr-2">Amounts</th>
                                </tr>
                            </thead>
                            <tbody >
                                <tr  style="border: none !important;" v-for="cn,index in comp_value_dedu" :key="index">
                                    <td class="pl-2">{{cn.comp_name}}</td>
                                    <td style="text-align: right;" class="pr-2">{{cn.comp_value}}.00</td>
                                </tr>
                                <tr v-if="comp_flag_dedu" style="border: none !important;" v-for="index in this.comp_loop_value" :key="index">
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="pl-2">Total Deduction</td>
                                    <td style="text-align: right;" class="pr-2">{{ total_deduct }}.00</td>
                                </tr>
                                <tr>
                                    <td class="pl-2">Net Pay</td>
                                    <td style="text-align: right;" class="pr-2">{{ net_sal }}.00</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="12" md="12">
                        <span class="pl-2"><strong>Note : {{ remark }} </strong></span>
                    </v-col>
                    <v-col class="mt-8 pt-5 pr-10" cols="12" sm="12" md="12" style="text-align: end;text-transform: uppercase;"><strong>Signature</strong></v-col>
                </div>
             
              
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import html2pdf from 'html2pdf.js'
    export default {
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            sal_month_list: [],
            sal_month: null,
            year: null,
            year_list: [],
            fmsg: null,
            emp: null,
            emp_code: null,
            emp_name: null,
            emp_type: null,
            emp_section: null,
            pan_no:null,
            increment_month:null,
            pay_commision:null,
            emp_designation: null,
            emp_pf_no: null,
            emp_bank_ac_no: null,
            emp_ifsc_code: null,
            emp_bank: null,
            net_sal_words: null,
            net_sal: null,
            working_days: null,
            total_earn: null,
            total_pay:null,
            total_deduct: null,
            remark:null,
            comp_value_earn: null,
            comp_value_dedu: null,
            salary_month: null,
            org_basic_data: null,
            date_of_joining: null,
            emp_uan_no: null,
            comp_loop_value:null,
            comp_flag_dedu:false,
            comp_flag_earn:false,
            pay_slip_addr_line_1:null
        }),
        methods: {
            fetchSalarySlip() {
                const data = {
                    sal_month: this.sal_month,
                };
                this.loader = true;
                axios
                    .post("/Payroll/getMonthlySalarySlip", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.emp = res.data.emp;
                            this.emp_code = res.data.emp_code;
                            this.emp_name = res.data.emp_name;
                            this.emp_type = res.data.emp_type;
                            this.emp_section = res.data.emp_section;
                            this.pan_no = res.data.pan_no;
                            this.increment_month = res.data.increment_month;
                            this.pay_commision = res.data.pay_commision;
                            this.emp_designation = res.data.emp_designation;
                            this.emp_pf_no = res.data.emp_pf_no;
                            this.emp_bank_ac_no = res.data.emp_bank_ac_no;
                            this.emp_ifsc_code = res.data.emp_ifsc_code;
                            this.emp_bank = res.data.emp_bank;
                            this.net_sal_words = res.data.net_sal_words;
                            this.net_sal = res.data.net_sal;
                            this.working_days = res.data.working_days;
                            this.total_earn = res.data.total_earn;
                            this.total_pay = res.data.total_pay;
                            this.total_deduct = res.data.total_deduct;
                            this.remark = res.data.remark;
                            this.comp_value_earn = res.data.comp_value_earn;
                            this.comp_value_dedu = res.data.comp_value_dedu;
                            this.pay_slip_addr_line_1 = res.data.pay_slip_addr_line_1
                            if(this.comp_value_earn.length > this.comp_value_dedu.length)
                            {
                                this.comp_loop_value = this.comp_value_earn.length - this.comp_value_dedu.length
                                this.comp_flag_dedu = true
                            }
                            else{
                                this.comp_loop_value = this.comp_value_dedu.length - this.comp_value_earn.length
                                this.comp_flag_earn = true
                            }
                            //alert(this.comp_loop_value)
                            this.salary_month = res.data.sal_month;
                            this.date_of_joining = res.data.date_of_joining;
                            this.emp_uan_no = res.data.emp_uan_no;
                            this.org_basic_data = res.data.org_basic_data;
                            this.loader = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.loader = false;
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader = false;
                    })
                    .finally(() => {});
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            download(){
                // const img = document.getElementById('myImage');
                // img.onload = () => {
                const componentsToHide = document.querySelectorAll('.no-display');
                componentsToHide.forEach(component => {
                    component.style.display = 'none';
                });
                const element = document.getElementById("box");
                
                const opt = {
                    // margin : 0,
                    filename : 'pay_slip.pdf',
                    image: { type: 'png', quality: 0.98},
                    jsPDF:  { unit: 'in', format: 'A4', orientation: 'portrait' },
                    
                };
                html2pdf().from(element).set(opt).save();
            // }
                },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.sal_month = localStorage.getItem("sal_month");
            this.fetchSalarySlip()
        },
        watch: {},
    };
</script>
<style scoped>
    /* .v-text-field{
      width: 80px;
} */
.schl-logo{
    margin-top: 20px;
}
    thead {
        font-weight: bold !important;
    }
    th,
    td {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border-collapse: collapse;
        border-left: 1px solid black;
        height: 28px;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border-collapse: collapse;
        border: 1px solid black;
    }
    #align-left {
        text-align: center;
        } 
    #align-right{
        text-align: center;
    }
    
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    table {
        white-space: nowrap !important;
        border-collapse: collapse;
        width: 100%;
    }

    @media print {
        @page {
            size: A4 !important;
            margin: 0 !important;
            padding: 0 !important;
            background-color: white !important;
            margin-top: -18px !important;
            margin-right: 15px !important;
            margin-left: -5px !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }       
        .box{
            border: none !important;  
        }
    }
    .stud_details2 {
        height: 5px;
        margin-bottom: 10px;
        margin-top: 0;
        background-color: black;
        width: 98%;
        margin-left: 15px;
    }
</style>
